<main #fullscreenContainer class="fullscreen-container">
  <section>
    <div #dialogContainer></div>
    <p-toolbar>
      <div class="p-toolbar-group-start">
        <div class="toolbar-top-row">
          <div class="left-section">
            <p-button [class.red]="legendCollapsed === true" class="action-button" (click)="toggleCollapse()"
              icon="pi pi-bars"></p-button>
            <span class="usermap-name">
              Map: <b>{{ !!(userMap | async) ? (userMap | async).mapName : "" }}</b>
            </span>
            <div class="toolbar-bottom-row">
              <div class="button-group">
                <p-button *ngIf="!isReadOnly" [disabled]="areMarkersBlocked" matTooltip="Add marker"
                  class="action-button" icon="pi pi-map-marker" (onClick)="addDataCenter()"></p-button>
                <p-button *ngIf="!isReadOnly" [disabled]="areMarkersBlocked" matTooltip="Add label"
                  class="action-button" icon="pi pi-tag" (onClick)="labelModalVisible = true"></p-button>
                <p-button *ngIf="!isReadOnly" [matTooltip]="areMarkersBlocked ? 'Unlock markers' : 'Lock markers'"
                  [class.red]="areMarkersBlocked" class="action-button" icon="pi pi-lock"
                  (onClick)="toggleMarkersDrag()"></p-button>
                <!--<p-button
                  *ngIf="!isReadOnly"
                  [matTooltip]="displayControls ? 'Hide map controls' : 'Show map controls'"
                  icon="pi pi-map"
                  [class.red]="!displayControls"
                  class="action-button"
                  (onClick)="toggleMapControls()"
                ></p-button>-->
                <p-button *ngIf="!isReadOnly" [matTooltip]="paintAreas ? 'Hide area circles' : 'Show area circles'"
                  icon="pi pi-circle" [class.red]="!paintAreas" class="action-button"
                  (onClick)="toggleAreaCircles()"></p-button>
                <p-button *ngIf="!isReadOnly" [matTooltip]="displayLines ? 'Hide lines' : 'Show lines'"
                  icon="pi pi-arrows-h" [class.red]="!displayLines" class="action-button"
                  (onClick)="toggleMapLines()"></p-button>
                <p-button *ngIf="!isReadOnly" [matTooltip]="displayPolygons ? 'Hide polygons' : 'Show polygons'"
                  icon="pi pi-share-alt" [class.red]="!displayPolygons" class="action-button"
                  (onClick)="toggleMapPolygons()"></p-button>
                <!-- NOTE: It is disabled temporarily because the new button in providers table makes the functionality more complete. -->
                <!-- <p-button
                  *ngIf="!isReadOnly"
                  [matTooltip]="displayMarkers ? 'Hide markers' : 'Show markers'"
                  icon="pi pi-map-marker"
                  [class.red]="!displayMarkers"
                  class="action-button"
                  (onClick)="toggleMarkers()"
                ></p-button> -->
                <p-button *ngIf="!isReadOnly" [matTooltip]="displayInfo ? 'Hide info' : 'Show info'"
                  icon="pi pi-info-circle" [class.red]="!displayInfo" class="action-button"
                  (onClick)="toggleInfoSquare()"></p-button>
                <p-button *ngIf="!isReadOnly && (PermissionEnum.MAPS_SAVE | hasPermission | async)"
                  class="action-button" matTooltip="Save map" icon="pi pi-save" (onClick)="saveMapData()"></p-button>
                <p-button *ngIf="!isReadOnly" class="action-button" matTooltip="Download CSV" icon="pi pi-download"
                  (onClick)="triggerCsvDownload()"></p-button>
              </div>
              <div class="button-group">
                <app-geo-filter></app-geo-filter>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-toolbar>
  </section>
  <div class="card-content">
    <div #resizableContainer class="legend" mwlResizable [enableGhostResize]="true" (resizing)="onResizing($event)"
      (resizeEnd)="onResizeEnd($event)" (resizeStart)="onResizeStart($event)" *ngIf="!legendCollapsed"
      [class.resizing]="isResizing" [style.width]="lastKnownWidth">
      <mat-card class="summary">
        <div class="resize-handle-right" mwlResizeHandle [resizeEdges]="{ right: true }"></div>
        <mat-card-content>
          <p-accordion value="5" id="accordionProviders">
            <p-accordion-panel value="0">
              <p-accordion-header>Availability Zones</p-accordion-header>
              <p-accordion-content>
                <app-availability-zones-sidebar></app-availability-zones-sidebar>
              </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="1">
              <p-accordion-header>Land / Parcel</p-accordion-header>
              <p-accordion-content>
                <app-files-table [mapFiles]="landMapFiles | async"></app-files-table>
              </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="2">
              <p-accordion-header>Networks</p-accordion-header>
              <p-accordion-content>
                <app-files-table [mapFiles]="fiberMapFiles | async"></app-files-table>
              </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="3">
              <p-accordion-header>Oil / Gas</p-accordion-header>
              <p-accordion-content>
                <app-files-table [mapFiles]="oilGasMapFiles | async"></app-files-table>
              </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="4">
              <p-accordion-header>Power</p-accordion-header>
              <p-accordion-content>
                <app-files-table [mapFiles]="powerMapFiles | async"></app-files-table>
              </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="5">
              <p-accordion-header>Providers</p-accordion-header>
              <p-accordion-content>
                <app-providers-table></app-providers-table>
              </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="6">
              <p-accordion-header>Railroad</p-accordion-header>
              <p-accordion-content>
                <app-files-table [mapFiles]="railroadMapFiles | async"></app-files-table>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="map-container" [ngClass]="{
        'map-container-exp': legendCollapsed,
        'map-container-col': !legendCollapsed
      }">
      <mgl-map [style]="style" [zoom]="[2]" [doubleClickZoom]="false" (mapLoad)="onloadmap($event)">
        <div *ngIf="displayControls">
          <mgl-control position="top-left">
            <mat-card style="padding-right: 10px">
              <mat-radio-group [ngModel]="layerId" (ngModelChange)="changeStyle($event)">
                <mat-radio-button value="basic">basic</mat-radio-button>
                <mat-radio-button value="streets">streets</mat-radio-button>
                <mat-radio-button value="bright">bright</mat-radio-button>
                <mat-radio-button value="light">light</mat-radio-button>
                <mat-radio-button value="dark">dark</mat-radio-button>
                <mat-radio-button value="satellite">satellite</mat-radio-button>
              </mat-radio-group>
            </mat-card>
          </mgl-control>
        </div>

        <mgl-marker *ngIf="!!(searchGeoInfoResult | async)" [lngLat]="[(searchGeoInfoResult | async).longitude,
          (searchGeoInfoResult | async).latitude]">
        </mgl-marker>

        <app-map-markers-gl *ngIf="displayMarkers" [map]="map">
        </app-map-markers-gl>
      </mgl-map>
    </div>
  </div>
  <p-toolbar>
    <div class="row" class="bottom-toolbar">
      <div class="col-4"></div>
      <div class="col-4 slider">
        <div class="slider-container">
          <p-slider (onSlideEnd)="onMwThresholdValueChange($event)" [(ngModel)]="mwThreshold" [step]="1"
            [max]="500"></p-slider>
        </div>
        <span style="color: white">MW threshold {{ mwThreshold }}</span>
      </div>
      <div class="col-4 buttons">
        <p-toggleButton (onChange)="unitsChanged($event)" [(ngModel)]="isMiles" offLabel="kms"
          onLabel="miles"></p-toggleButton>
      </div>
    </div>
  </p-toolbar>
</main>
<app-providers-datacenters-details></app-providers-datacenters-details>
<p-dialog id="tilesetData" [closable]="false" [modal]="true" [(visible)]="displayTilesetMetadata"
  [style]="{ width: '25rem' }">
  @if (fileMetadata) {
  <ng-template #header>
    <div class="flex flex-col">
      <div>
        <span class="popup-tittle">{{ fileMetadata.fileName }}</span>
      </div>
      <div>
        <span class="modification-info">Uploaded by {{ mapfileUser?.fullName }}
          on {{ fileMetadata.uploadDate | date: 'MM/dd/yyyy' }}</span>
      </div>
    </div>
  </ng-template>
  <ng-template #content>
    <div class="flex-container">
      @if (fileMetadata.supplier) {
      <div class="field-value">
        <span class="field">Provider:</span>
        <span class="value">{{ fileMetadata.supplier }}</span>
      </div>
      }
      <div class="field-value">
        <span class="field">Map type:</span>
        <span class="value">{{ getMapTypeFriendlyName(fileMetadata.mapType) }}</span>
      </div>
      @if (fileMetadata.mapSource) {
      <div class="field-value">
        <span class="field">Map source:</span>
        <span class="value">{{ fileMetadata.mapSource }}</span>
      </div>
      }
      @if (fileMetadata.nda) {
      <div class="field-value">
        <span class="field">Nda:</span>
        <span class="value">{{ fileMetadata.nda === 'true' ? 'Yes' : 'No' }}</span>
      </div>
      }
    </div>
    @if (fileMetadata.metadata?.length) {
    <div>
      <div style="margin-top: 10px; margin-bottom: 10px;">
        <span class="field">Data:</span>
      </div>
      <div class="field-value" style="min-height: 250px; overflow: hidden;">
        <p-tabs value="0">
          <p-tablist>
            @for (metadata of fileMetadata.metadata; track $index) {
            <p-tab value="{{ $index }}">Data {{ $index + 1 }}</p-tab>
            }
          </p-tablist>
          <p-tabpanels>
            @for (metadata of fileMetadata.metadata; track $index) {
            <p-tabpanel value="{{ $index }}">
              <p-table [value]="metadata" stripedRows [style]='{"max-width":"320px"}' [scrollable]="true"
                scrollHeight="250px">
                <ng-template #body let-data>
                  <tr>
                    <td style="text-align: right;font-weight: bold;">{{ data.label }}</td>
                    <td style="text-align: left;">{{ data.label.toUpperCase().indexOf('DATE') != -1 ? (data.value |
                      date: 'MM/dd/yyyy') : data.value }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </p-tabpanel>
            }
          </p-tabpanels>
        </p-tabs>
      </div>
    </div>
    }
  </ng-template>
  <ng-template #footer>
    <p-button label="Close" (click)="onMetadataClose()"></p-button>
  </ng-template>
  }
</p-dialog>

<p-dialog header="Label" [modal]="true" [(visible)]="labelModalVisible" [style]="{ width: '25rem' }">
  <div class="form-group">
    <label for="mapIdTxt">Text</label>
    <input #labelTxt  class="form-control" type="text" pInputText id="label" name="label" />
  </div>
  <div class="flex justify-end gap-2 mt-3">
    <p-button  label="Cancel" severity="secondary" (click)="labelModalVisible = false" />
    <p-button label="Save" (click)="saveLabel(labelTxt)" class="ms-2" />
  </div>
</p-dialog>